
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graphiql",
      function () {
        return require("private-next-pages/graphiql.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graphiql"])
      });
    }
  